import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

import {
	API_PROJECT,
	ROLE_SP_SYSTEM_ADMINISTRATOR,
	ROLE_SP_AWARD_ADMINISTRATOR,
	ROLE_SP_PROPOSAL_ADMINISTRATOR,
	COLUMN_HEADER_KEYS,
} from "globals/constants";
import { spUrl } from "utils";
import FormAttachmentsView  from "components/FormAttachmentsView";
import { useHasRoles } from "hooks";
import { projectSelectors, shellSelectors, tenantSelectors } from "store/selectors";


const ProjectAttachmentsView = ({ setFindFormElement, tabsRef, formTabText, isUploading, setIsUploading }) => {
	const project = useSelector(projectSelectors.project);
	const { fullName } = useSelector(shellSelectors.user);
	const { projectAttachmentTypes } = useSelector(tenantSelectors.tenant);

	const attachmentsUrl = spUrl(`${API_PROJECT}/${project.projectId}/attachments`);

	const {
		[ROLE_SP_SYSTEM_ADMINISTRATOR]: isSystemAdmin,
		[ROLE_SP_AWARD_ADMINISTRATOR]: isAwardAdmin,
		[ROLE_SP_PROPOSAL_ADMINISTRATOR]: isProposalAdmin,
	} = useHasRoles([
		ROLE_SP_SYSTEM_ADMINISTRATOR,
		ROLE_SP_AWARD_ADMINISTRATOR,
		ROLE_SP_PROPOSAL_ADMINISTRATOR
	]);

	const canEditAttachments = (isSystemAdmin || isAwardAdmin || isProposalAdmin);

	const formInstance = {
		instance: project,
		instanceId: project.projectId,
		endpoint: API_PROJECT,
		type: COLUMN_HEADER_KEYS.PROJECT
	};

	const projectAttachmentTypesArray = Array.isArray(projectAttachmentTypes) ? projectAttachmentTypes : [];

	return (
		<FormAttachmentsView
			formInstance = {formInstance}
			fullName = {fullName}
			attachmentTypes = {projectAttachmentTypesArray}
			attachmentsUrl = {attachmentsUrl}
			setFindFormElement = {setFindFormElement}
			tabsRef = {tabsRef}
			formTabText = {formTabText}
			canAddAttachments = {canEditAttachments}
			canEditAttachments = {canEditAttachments}
			setIsUploading={setIsUploading}
			isUploading={isUploading}
		/>
	);
};

ProjectAttachmentsView.propTypes = {
	setFindFormElement: PropTypes.func.isRequired,
	tabsRef: PropTypes.object
};

export default ProjectAttachmentsView;
